import { requireCreatorViewer } from "./data/creator-viewer";
import { readSharedCoworld } from "./creator.data";

export function admitCreator() {
  return requireCreatorViewer({});
}

export function getSharedCoworld({
  name,
  search,
  signal,
}: {
  name: string;
  search: string;
  signal?: AbortSignal | undefined;
}) {
  return readSharedCoworld({ name, search, signal });
}
